import React from 'react'
import styled from "styled-components";
import {useTranslation} from "react-i18next";

export const GridContentBox = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    width: 100%;
    gap: 14px;
    margin-bottom: 14px;
		
		&[data-grid-template-columns='1'] {
        grid-template-columns: repeat(1, 1fr);
		}

    &[data-grid-template-columns='2'] {
        grid-template-columns: repeat(2, 1fr);

        //TODO: check the media point transition
        @media all and (max-width: 1200px) {
            grid-template-columns: repeat(1, 1fr);
        }
    }

    &[data-grid-template-columns='3'] {
        grid-template-columns: repeat(3, 1fr);

        //TODO: check the media point transition
        @media all and (max-width: 1400px) {
            grid-template-columns: repeat(2, 1fr);
        }
        @media all and (max-width: 1000px) {
            grid-template-columns: repeat(1, 1fr);
        }
    }

    &[data-grid-template-columns='4'] {
        grid-template-columns: repeat(4, 1fr);
				
        @media all and (max-width: 1400px) {
            grid-template-columns: repeat(3, 1fr);
        }
        @media all and (max-width: 1200px) {
            grid-template-columns: repeat(2, 1fr);
        }
    }
`

const InfoBoxWrapper = styled.div`
    display: inline-flex;
    width: 50%;
    padding: 7px;
`

const InfoBox = styled.div`
    display: flex;
    width: 100%;
    padding: 16px 16px 0 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 24px;

    border: 1px solid var(--it-stroke-grey);
    background: var(--it-bg-cards, rgba(238, 238, 238, 0.03));
`

const HeaderBox = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
`

const HeaderTitle = styled.div`
    color: var(--it-text-white);

    /* H4 */
    font-family: "Druk Wide";
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 120%; /* 16.8px */
    letter-spacing: 0.42px;
    text-transform: uppercase;
`

const BoxContent = styled.div`
    width: 100%;
`

export const InfoBlock = ({
														title = '',
														icon = null,
														styleHeader = {},
														styleContent = {},
														withFlexWrapper = false,
														children
													}) => {
	const {t} = useTranslation();
	const _renderHeaderTitleBox = () => {
		return title ? (
			<HeaderBox style={styleHeader}>
				<HeaderTitle>{t(title)}</HeaderTitle>
				{icon ? icon : null}
			</HeaderBox>
		) : null
	}

	const _content = (
		<InfoBox style={styleContent}>
			{_renderHeaderTitleBox()}

			<BoxContent>{children}</BoxContent>
		</InfoBox>
	);

	return withFlexWrapper ? <InfoBoxWrapper>{_content}</InfoBoxWrapper> : <>{_content}</>;
}